import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'
import i18n from '@/utils/i18n'
import HOME from '@/views/allApps/home.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  // 包含HeaderTop和Footer的路由
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: HOME,
        meta: {
          title: 'route.title.home',
          keepAlive: false
        },
        props: true
      },
      {
        path: 'allApps',
        name: 'AllApps',
        component: () => import('@/views/allApps/index.vue'),
        meta: {
          title: 'route.title.industry.mall',
          keepAlive: false
        },
        props: true
      },
      {
        path: 'appDetail/:productId',
        name: 'AppDetail',
        component: () => import('@/views/appDetail/index.vue'),
        meta: {
          title: 'route.title.app.detail',
          keepAlive: false
        },
        props: true
      },
      {
        path: 'myApps',
        name: 'MyApps',
        component: () => import('@/views/myApps/index.vue'),
        meta: {
          title: 'route.title.my.apps',
          keepAlive: false
        },
        props: true
      },
      {
        path: 'myApps/:orderId',
        name: 'MyAppsDetail',
        component: () => import('@/views/myApps/AppItem.vue'),
        meta: {
          title: 'route.title.my.apps.detail',
          keepAlive: false
        },
        props: true
      },
      {
        path: 'partnership',
        name: 'Partnership',
        component: () => import('@/views/partnership/index.vue'),
        meta: {
          title: 'route.title.partnership',
          keepAlive: false
        },
        props: true
      },
      {
        path: 'invoice',
        name: 'InvoiceManagement',
        component: () => import('@/views/invoice/index.vue'),
        meta: {
          title: 'route.title.invoice.management',
          keepAlive: true
        },
        props: true
      },
      {
        path: 'invoice/create',
        name: 'CreateInvoice',
        component: () => import('@/views/invoice/createInvoice.vue'),
        meta: {
          title: 'route.title.create.invoice',
          keepAlive: false
        },
        props: true
      },
      {
        path: 'invoice/:id',
        name: 'InvoiceDetail',
        component: () => import('@/views/invoice/invoiceDetail.vue'),
        meta: {
          title: 'route.title.invoice.detail',
          keepAlive: true
        },
        props: true
      },
      {
        path: 'personal',
        name: 'Personal',
        component: () => import('@/views/personal/index.vue'),
        meta: {
          title: 'route.title.personal.center',
          keepAlive: true
        },
        props: true
      },
      {
        path: 'trial/:productId',
        name: 'Trial',
        component: () => import('@/views/trial/index.vue'),
        meta: {
          title: 'route.title.app.detail',
          keepAlive: true
        },
        props: true
      },
      {
        path: 'pricing',
        name: 'Pricing',
        component: () => import('@/views/pricing/index.vue'),
        meta: {
          title: 'header.pricing.plan',
          keepAlive: true
        },
        props: true
      },
    ]
  },
  // 不包含HeaderTop和Footer的路由
  {
    path: '/appList',
    name: 'AppList',
    component: () => import('@/views/allApps/appList.vue'),
    meta: {
      title: 'route.title.app.list',
      keepAlive: true
    },
    props: true
  },
  // 404页面
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/views/404/index.vue'),
    meta: {
      title: 'route.title.page.not.found'
    }
  }
]

const router = new VueRouter({
  // mode: 'history', // 注释掉history模式，使用默认的hash模式
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

// 路由守卫 - 可以在这里添加权限验证、页面标题设置等
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    // 如果title是国际化键，则进行翻译；否则直接使用
    if (to.meta.title.startsWith('route.title.') || to.meta.title.startsWith('header.')) {
      document.title = i18n.t(to.meta.title)
    } else {
      document.title = to.meta.title
    }
  }

  // 处理binding参数 - 使用CCDK存储token
  if (to.query.binding) {
    const binding = to.query.binding;
    console.log('binding', binding);
    try {
      // 使用CCDK存储token
      if (window.$CCDK && window.$CCDK.CCToken) {
        window.$CCDK.CCToken.setToken(binding, 'partnerToken');
      }
      
      // 移除binding参数，避免在URL中保留敏感信息
      const query = { ...to.query };
      delete query.binding;
      
      // 如果有其他查询参数，保留它们；如果没有，跳转到当前路径但不带参数
      next({
        path: to.path,
        query: query,
        replace: true // 使用replace避免在浏览器历史中保留带token的URL
      });
      return;
    } catch (error) {
      console.error('存储token时出错:', error);
    }
  }

  next()
})

// 每次路由切换后统一处理：重置滚动条 + 注入百度统计
router.afterEach((to, from) => {
  // 1. 重置自定义滚动容器滚动条
  Vue.nextTick(() => {
    const container = document.querySelector('.main-content')
    if (container) {
      if (typeof container.scrollTo === 'function') {
        container.scrollTo({ top: 0, left: 0 })
      } else {
        container.scrollTop = 0
        container.scrollLeft = 0
      }
    }
  })

  // 2. 注入百度统计脚本（避免重复插入）
  setTimeout(() => {
    // 确保只加载一次脚本，并在SPA路由切换时手动上报
    window._hmt = window._hmt || []
    if (!document.getElementById('baidu_tj')) {
      const hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?16faf8dcf9afcd18a5e6b733b8765617'
      hm.id = 'baidu_tj'
      const s = document.getElementsByTagName('script')[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(hm, s)
      } else {
        document.head.appendChild(hm)
      }
    }
    // 推送页面浏览事件（Baidu Tongji在SPA需手动触发）
    try {
      const pageUrl = (location.pathname || '/') + (location.search || '') + (location.hash || '')
      window._hmt.push(['_trackPageview', pageUrl])
    } catch (e) {}
  }, 0)
})

export default router


